import cn from 'clsx';
import { PropsWithChildren } from 'react';

interface ParagraphProps extends PropsWithChildren {
  readonly isError?: boolean;
  readonly ellipsisOnOverflow?: boolean;
  readonly disabled?: boolean;
  readonly extraClassName?: string;
}

const styles = {
  paragraph: 'font-app font-normal m-0',
  errorParagraph: 'text-error',
  paragraphOverflow:
    'overflow-hidden whitespace-nowrap overflow-ellipsis w-full',
};

export function Paragraph({
  isError = false,
  ellipsisOnOverflow,
  disabled = false,
  extraClassName,
  children,
}: ParagraphProps) {
  return (
    <p
      className={cn(
        styles.paragraph,
        isError && styles.errorParagraph,
        ellipsisOnOverflow ? styles.paragraphOverflow : 'whitespace-pre-wrap',
        disabled && 'disabled',
        extraClassName,
      )}
    >
      {children}
    </p>
  );
}
